import { render, staticRenderFns } from "./modellist.vue?vue&type=template&id=5130824a&scoped=true"
import script from "./modellist.vue?vue&type=script&lang=js"
export * from "./modellist.vue?vue&type=script&lang=js"
import style0 from "./modellist.vue?vue&type=style&index=0&id=5130824a&prod&lang=scss"
import style1 from "./modellist.vue?vue&type=style&index=1&id=5130824a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5130824a",
  null
  
)

export default component.exports